import { allocateProportional } from "@cx/domain";

export type EstimateLine = {
  productId: string | null;
  qtyQ4: number;
  unitPriceCents: number;
  totalCents: number;
};
export type EstimateInput = {
  contactId: string | null;
  lines: EstimateLine[];
  discountCents: number;
  freightCents: number;
  otherExpensesCents: number;
};

/**
 * Corpo do `POST /tax/simulate` do painel "Impostos estimados". Itens sem produto ficam de fora (sem NCM); o desconto,
 * o frete e as outras despesas do documento entram só com a parte dos produtos (rateio pelo total líquido, 05 §3),
 * senão o desconto geral sobre um item avulso grande passaria do total dos produtos. null = nada a simular.
 */
export function estimateBody(p: EstimateInput, operationId: string) {
  const products = p.lines.filter((l) => l.productId && l.qtyQ4 > 0);
  if (!p.contactId || products.length === 0) return null;
  const sum = (ls: EstimateLine[]) => ls.reduce((a, l) => a + l.totalCents, 0);
  const own = sum(products);
  const rest = sum(p.lines) - own;
  const part = (cents: number) => (rest > 0 ? allocateProportional(cents, [own, rest])[0]! : cents);
  return {
    taxOperationId: operationId || null,
    contactId: p.contactId,
    items: products.map((l) => ({
      productId: l.productId,
      qtyQ4: l.qtyQ4,
      unitPriceCents: l.unitPriceCents,
      totalCents: l.totalCents,
    })),
    discountCents: part(p.discountCents),
    freightCents: part(p.freightCents),
    otherExpensesCents: part(p.otherExpensesCents),
  };
}
